import { Box, Divider, Stack, Typography } from "@mui/material";
import addImg from "../../images/checkoutAd.jpg"
import { useAuth } from "../../context/GlobalState";
import CheckoutProduct from "./CheckoutProduct";
import Subtotal from "./Subtotal";
export default function Checkout() {
    const {user} = useAuth();
  return (
    <Box>

        <Stack flexDirection={{md:"row" , xs:"column"}} gap={1} alignItems={"center"} mt={2}>

        <Typography variant="body2" m={{md:2 , lg:1}} 
         width={{xs:"100%" ,md:"75%" }} sx={{ height:{xs:"70px" , md:"100%" }}} >

        <img src={addImg} style={{width:"100%" , height:"100%"}}/>
        </Typography>

        <Typography mb={{sm:2}} width={{xs:"100%" , md:"23%"}}>
        <Subtotal/>

        </Typography>

        </Stack>


        <Typography variant="h6" ml={2} fontWeight={600}>
            Hello, {user?user.email: "Guest"}
        </Typography>


        <Typography variant="h5" m={3} fontWeight={600}>
        Your Shopping Basket
        </Typography>

        <Divider sx={{mt:3}}/>


        <Stack flexDirection={'column'}>
            <CheckoutProduct/>
        </Stack>


    </Box>
  )
}
